import { render, staticRenderFns } from "./IconNew.vue?vue&type=template&id=05c58432&scoped=true"
import script from "./IconNew.vue?vue&type=script&lang=js"
export * from "./IconNew.vue?vue&type=script&lang=js"
import style0 from "./IconNew.vue?vue&type=style&index=0&id=05c58432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c58432",
  null
  
)

export default component.exports